<template>
	<div class="page-container" style="padding: 20px;">
		<!-- 返回 + 标题 -->
		<div style="display: flex; align-items: center; margin-bottom: 20px;">
			<el-button icon="el-icon-arrow-left" @click="goBack">返回</el-button>
			<div style="margin-left: 15px; font-size: 16px;">
				学校：<span style="color:#409EFF; font-weight:bold">{{ schoolName }}</span> - 学科配置
			</div>
		</div>

		<!-- 只渲染学校拥有的学段 -->
		<el-row :gutter="20">
			<el-col 
				:span="12" 
				v-for="(stage, idx) in stageList" 
				:key="idx"
				v-if="schoolStageCodes.includes(stage.code)"
			>
				<el-card :header="stage.name" style="margin-bottom:20px;">
					<el-checkbox-group v-model="checkedSubjects[stage.code]">
						<el-checkbox 
							v-for="sub in stage.subjectList" 
							:key="sub.id" 
							:label="sub.id"
							:disabled="isExist(sub.id)"
							@change="(val) => handleCheck(val, sub, stage.code)">
							{{ sub.subjectName }}
						</el-checkbox>
					</el-checkbox-group>
				</el-card>
			</el-col>
		</el-row>

		<!-- 无学段提示 -->
		<div style="text-align:center; margin-top:40px; color:#999;" v-if="schoolStageCodes.length === 0">
			该学校未配置学段
		</div>
	</div>
</template>

<script>
	export default {
		name: "SchoolSubjectEdit",
		data() {
			return {
				schoolId: "",
				schoolName: "",
				stageList: [
					{ code: "1", name: "小学", subjectList: [] },
					{ code: "2", name: "初中", subjectList: [] },
					{ code: "3", name: "高中", subjectList: [] },
					{ code: "4", name: "中职", subjectList: [] },
				],
				schoolStageCodes: [],
				checkedSubjects: { 1: [], 2: [], 3: [], 4: [] },
				centerSubjectList: [],
				existSubjectIdSet: new Set() // 学校已有学科ID
			};
		},
		created() {
			this.schoolId = this.$route.query.schoolId;
			this.schoolName = this.$route.query.schoolName;
			this.getCenterSubject();
		},
		methods: {
			goBack() {
				this.$router.go(-1);
			},

			// 1. 获取中台学科
			getCenterSubject() {
				this.API.get(this.API.admin.getAdminSubjectList,{
					pageSize:100,
					pageNum:1
				}).then(res => {
					let list = res.data.data.records || [];
					this.centerSubjectList = list;

					this.stageList.forEach(stage => {
						stage.subjectList = list.filter(sub => {
							return sub.gradeRangeList && sub.gradeRangeList.split(',').includes(stage.code);
						});
					});
					this.getSchoolSubjects();
				});
			},

			// 2. 获取学校已有学科
			getSchoolSubjects() {
				this.API.get(this.API.admin.getschoolSubjectList, {
					schoolId: this.schoolId,
					pageSize:100,
					pageNum:1
				}).then(res => {
					let records = res.data.data.records || [];

					// 收集已有学科ID → 用于禁用
					this.existSubjectIdSet.clear();
					records.forEach(item => {
						this.existSubjectIdSet.add(item.subjectId);
					});

					// 收集学校学段
					let codes = new Set();
					records.forEach(i => codes.add(i.stageCode));
					this.schoolStageCodes = Array.from(codes);

					// 回填勾选
					this.checkedSubjects = {1:[],2:[],3:[],4:[]};
					records.forEach(item => {
						this.checkedSubjects[item.stageCode].push(item.subjectId);
					});
				});
			},

			// 判断是否已存在 → 禁用
			isExist(subjectId) {
				return this.existSubjectIdSet.has(subjectId);
			},

			// ====================== 勾选立即调用新增接口 ======================
			handleCheck(val, subject, stageCode) {
				// 只处理勾选
				if (!val) return;

				let params = {
					schoolId: this.schoolId,
					stageCode: stageCode,
					subjectId: subject.id,
					subjectName: subject.subjectName,
					status: 1
				};

				this.API.post(this.API.admin.postschoolSubjectAdd, params).then(res => {
					this.$message.success(res.data.msg);
					// 加入已存在，立刻禁用
					this.existSubjectIdSet.add(subject.id);
				});
			},
		}
	};
</script>

<style scoped>
	.page-container {background: #fff; min-height: calc(100vh - 80px);}
</style>